import React, { Component } from 'react';

class VistaModificacionEstado extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        let GET_PARAMETRIA;

        if (this.props.data) {
            GET_PARAMETRIA = this.props.data.GET_PARAMETRIA;
        }

        const novedadesNodos = (this.props.data || []).map((novedad) => {
            let elementos = []

            let fechaModificacion = novedad.FechaHoraModificacion.replace("T", " ").replace("Z", "");
            let fecha = fechaModificacion.substring(0, 10).split("-");
            let hora = fechaModificacion.substring(16, 11) + "hs";
            let editadoPor = `Editado por ${novedad.UsuarioLoginModificacion}.`;
            let claseRectangulo = "";

            if (novedad.RegistroInicial == true) {
                claseRectangulo = "div-rectangulo reg-inicial";
            } else {
                claseRectangulo = `div-rectangulo ${novedad.NovedadEstadoDescripcion.toLowerCase().replace(/\s/g, "-")}`;
            }

            if (GET_PARAMETRIA) {
                let encontrado = false;

                GET_PARAMETRIA.forEach((gp, index, self) => {
                    if (encontrado == false) {
                        for (let key in gp) {
                            if (key.toLowerCase() == "id" && gp[key] == novedad.ValorHistorico) {
                                encontrado = true;
                            }
                        }

                        if (encontrado == true) {
                            for (let key in gp) {
                                if (key.toLowerCase() == "descripcion") {
                                    novedad.ValorNovedadDescripcion = gp[key];
                                }
                            }
                        }
                    }
                });
            }

            elementos.push(
                <div className="row">
                    <div className="col-xs-3">
                        <label className="label-central">{`${fecha[2]}/${fecha[1]}/${fecha[0]}`}</label>
                    </div>
                    <div className="col-xs-6">
                        <label className="label-central">{novedad.ValorNovedadDescripcion || novedad.ValorHistorico}</label>
                    </div>
                    <div className="col-xs-3">
                        <div className={claseRectangulo}>
                            <label className="rectangulo-label">{novedad.NovedadEstadoDescripcion.toUpperCase()}</label>
                        </div>
                    </div>
                </div>
            );

            elementos.push(
                <div className="row">
                    <div className="col-xs-3">
                        <label className="label-central-small">{hora}</label>
                    </div>
                    <div className="col-xs-9">
                        <label className="label-central-small">{editadoPor}</label>
                    </div>
                </div>
            );

            return elementos;
        });

        return (
            <div>
                {novedadesNodos}
            </div>
        );
    }
}

export default VistaModificacionEstado